import React, { useState } from "react";
import { CalendarPlus, MessageCircle } from "lucide-react";
import { papi } from "../../../lib/portalApi";
import { formatDate } from "../../../lib/api";
import { InfoSheet } from "./InfoSheet";
import { T, track } from "./theme";
import { toast } from "sonner";

// .ics local: o lembrete fica so no calendario do aparelho (nenhuma mensagem e enviada).
const downloadIcs = (due, it) => {
  const d = due.replace(/-/g, "");
  const ics = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Cris Cliente//Lembrete//PT", "BEGIN:VEVENT",
    `UID:${it.installment_id}@cris-cliente`, `DTSTART;VALUE=DATE:${d}`, `SUMMARY:Parcela ${it.segment} vence hoje`,
    "DESCRIPTION:Consulte o valor atualizado e pague pelo Portal Cris Cliente.",
    "BEGIN:VALARM", "TRIGGER:-P1D", "ACTION:DISPLAY", "DESCRIPTION:Sua parcela vence amanhã", "END:VALARM",
    "END:VEVENT", "END:VCALENDAR"].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar;charset=utf-8" }));
  const a = document.createElement("a"); a.href = url; a.download = `lembrete-parcela-${due}.ics`; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const ReminderSheet = ({ ctx, reminder, onClose, onChanged }) => {
  const [busy, setBusy] = useState(false);
  if (!ctx) return null;
  const { nextDue, it } = ctx;
  const rulerOn = reminder.ruler_d1[it.bu === "eletros" ? "eletros" : "cris"];
  const setConsent = async (consent) => {
    setBusy(true);
    try { const { data } = await papi.post("/portal/reminders/whatsapp", { consent }); onChanged(data); toast.success(consent ? "Lembrete por WhatsApp autorizado" : "Lembrete por WhatsApp desativado"); }
    catch { toast.error("Não foi possível salvar agora."); }
    finally { setBusy(false); }
  };
  return (
    <InfoSheet open onClose={onClose} title="Lembrar-me" description={`Parcela com vencimento em ${formatDate(nextDue.due_date)}`} testid="reminder-sheet">
      <button onClick={() => { track("reminder_calendar", `${it.bu}:${it.installment_id}`); downloadIcs(nextDue.due_date, it); }}
        className="flex w-full items-center gap-3 rounded-2xl p-4 text-left" style={{ background: T.lavender }} data-testid="reminder-calendar-btn">
        <CalendarPlus size={22} style={{ color: T.violet }} />
        <span><b className="block">Adicionar à agenda do celular</b><span className="text-[13px]" style={{ color: T.muted }}>Aviso um dia antes, direto no seu calendário.</span></span>
      </button>
      <div className="rounded-2xl border p-4" style={{ borderColor: T.line }} data-testid="reminder-whatsapp-box">
        <div className="flex items-center gap-2"><MessageCircle size={20} style={{ color: T.green }} /><b>Lembrete pelo WhatsApp oficial</b></div>
        {!reminder.has_phone ? (
          <p className="mt-2 text-[13px]" style={{ color: T.muted }} data-testid="reminder-whatsapp-no-phone">Cadastre seu WhatsApp com a sua revendedora para receber lembretes.</p>
        ) : !rulerOn ? (
          <p className="mt-2 text-[13px]" style={{ color: T.muted }} data-testid="reminder-whatsapp-unavailable">Lembrete por WhatsApp indisponível no momento. Use o lembrete na agenda.</p>
        ) : (
          <>
            <p className="mt-2 text-[13px]" style={{ color: T.muted }}>O aviso do dia anterior é enviado pela régua de cobrança oficial, sem mensagens repetidas.</p>
            {reminder.consent
              ? <button disabled={busy} onClick={() => setConsent(false)} className="mt-3 w-full rounded-xl border py-2.5 text-[14px] font-bold" style={{ borderColor: T.line, color: T.muted }} data-testid="reminder-whatsapp-optout-btn">Autorizado em {formatDate(reminder.consent_at)} · desativar</button>
              : <button disabled={busy} onClick={() => setConsent(true)} className="mt-3 w-full rounded-xl py-2.5 text-[14px] font-bold text-white" style={{ background: T.green }} data-testid="reminder-whatsapp-optin-btn">Autorizo receber o lembrete por WhatsApp</button>}
          </>
        )}
      </div>
    </InfoSheet>
  );
};
